import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, take } from 'rxjs';
import * as fromGenerated from '../../_generated';
import { AssistantsActions } from './store/assistants.actions';
import { assistantsFeature, AssistantsState } from './store/assistants.reducer';

/**
 * Holds the chats routes until the skills have loaded. That wait is its job:
 * nothing reads the list it resolves, because no routed component takes an
 * `assistants` input. The list is still the filtered one, without
 * role-read-only skills, so the raw list keeps no reader outside the reducer
 * (`assistants.list-selector.containment.spec.ts`).
 */
export const assistantsResolver: ResolveFn<fromGenerated.AssistantView[]> = (
  _route,
  _state,
) => {
  const assistantsStore = inject<Store<AssistantsState>>(Store);

  if (assistantsStore.selectSignal(assistantsFeature.selectLoaded)()) {
    return of(
      assistantsStore.selectSignal(assistantsFeature.selectAllListed)(),
    );
  }

  assistantsStore.dispatch(AssistantsActions.loadAssistants());

  return assistantsStore.select(assistantsFeature.selectLoaded).pipe(
    filter((loaded) => loaded),
    take(1),
    switchMap(() => assistantsStore.select(assistantsFeature.selectAllListed)),
  );
};
